import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'components';
import {
  useCommercialOfferListQuery,
  useCopyCommercialOfferMutation,
  useDealByIdQuery,
  useDeleteCommercialOfferMutation,
} from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useState } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';

export const useCommercialOffers = () => {
  const [addCommercialOfferState, setAddCommercialOfferState] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>() as { id: string };
  const navigate = useNavigate();
  const [rejectForm] = Form.useForm();
  const [negotiateForm] = Form.useForm();
  const { data: dealDetails = {} } = useDealByIdQuery({ id }, { skip: !id });
  const { isFinalStatus } = dealDetails;
  const { data: offers = [], isLoading: isLoadingOffer } = useCommercialOfferListQuery(id as string, {
    skip: !id,
  });
  const [createCopy] = useCopyCommercialOfferMutation();
  const [deleteOffer] = useDeleteCommercialOfferMutation();
  const { handleSuccess, handleError } = useNotificationMessages();

  // Handle creating a new offer
  const handleCreateOffer = () => {
    setAddCommercialOfferState(true);
  };
  const handleCancelOffer = () => {
    setAddCommercialOfferState(false);
  };

  const handleViewOffer = (offerId: string) => {
    navigate(`${ADMIN_ROUTES.deals.view}/${id}/${ADMIN_ROUTES.deals.commercialOfferUpdate}/${offerId}`);
  };

  // Handle creating a copy of an offer
  const handleCreateCopy = async (commercialOfferId: string) => {
    try {
      const res = createCopy({ commercialOfferId });
      console.log(res, '✅ => res');
    } catch (err) {
      handleError(err);
    }
    //handleSuccess(`Creating a copy of offer with ID: ${commercialOfferId}`);
  };

  // Handle deleting an offer
  const handleDeleteOffer = async (offerId: string) => {
    try {
      await deleteOffer(offerId).unwrap();
      handleSuccess(`Offer deleted successfully`);
    } catch (err) {
      console.error('Failed to delete offer:', err);
      handleError(err);
    }
  };

  return {
    id,
    offers,
    rejectForm,
    negotiateForm,
    isLoadingOffer,
    handleError,
    handleSuccess,
    handleViewOffer,
    handleCreateCopy,
    handleCreateOffer,
    handleDeleteOffer,
    handleCancelOffer,
    isFinalStatus,
    addCommercialOfferState,
  };
};
